function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVictoryReactionsEnvy = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 325.13 325.13",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162.56,
    cy: 162.57,
    r: 150.03,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.92,
    y1: 119.19,
    x2: 130.88,
    y2: 119.19,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.07,
    y1: 119.19,
    x2: 237.03,
    y2: 119.19,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.27,
    y1: 228.93,
    x2: 191.25,
    y2: 228.93,
    style: {
      fill: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.88,
    cy: 131.05,
    r: 12,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.03,
    cy: 131.05,
    r: 12,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVictoryReactionsEnvy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Victory_Reactions_Envy.65ba0677.svg";
export { ForwardRef as ReactComponent };